/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCalendarRequest} from '@cash-web/protos/squareup/cash/billy/api/v1_0/app/GetCalendar.pb'
import {GetCalendarResponse} from '@cash-web/protos/squareup/cash/billy/api/v1_0/app/GetCalendar.pb'


export const getCalendar = (request:GetCalendarRequest, options?: CashRequestOptions) => post<GetCalendarRequest, GetCalendarResponse>("/2.0/cash/get-calendar", request, {...options, rejectOnError: true })